var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('TransactionTemplate',{ref:"invoice-credit",staticClass:"invoice-credit",attrs:{"screenJson":_vm.getScreenJson,"setLoading":_vm.setLoading,"backButtonRoute":_vm.backButtonRoute,"paging":false,"validationSummary":_vm.validationSummary}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }